import { Button } from "@mui/material";
import React from "react";
import { DefaultDialogProps } from "../../../components/default-dialog";
import DefaultDrawer from "../../../components/default-drawer";
import { useBaseLayoutController } from "../../../base-layout/context/base-layout-controller";
import SaveIcon from '@mui/icons-material/Save';
import { useContratosState } from "../context/contratos-context";
import { useContratosController } from "../context/contratos-controller";
import { ContratoForm } from "./contrato-form";

export const ContratoDrawer = () => {
    const { showDialog } = useBaseLayoutController();
    const { save, closeForm } = useContratosController();
    const { dataResponse, showAddEdit } = useContratosState();

    const getTitle = (): string => {
        if (dataResponse !== undefined && dataResponse !== null && dataResponse?.id !== null)
            return `Editar Contrato ${dataResponse?.id}`;
        return "Adicionar Contrato";
    };

    return (
        <DefaultDrawer isOpen={showAddEdit} title={getTitle()} onClose={closeForm}
            actions={() => (
                <Button variant="contained" endIcon={<SaveIcon />} onClick={() => {
                    showDialog({
                        open: true,
                        message: "Deseja realmente salvar essa informação?",
                        onYesClick: () => {
                            (async () => {
                                await save();
                            })();
                        }
                    } as DefaultDialogProps);
                }}>
                    Salvar
                </Button>
            )}>
            <ContratoForm />
        </DefaultDrawer>
    );
};
